
type cb_message_t = (msg:Message) => void;

export default class Message {

    //
    // Static
    //
    static callback: cb_message_t|null;
    static onMessage(cb: cb_message_t){
        this.callback = cb;
    }

    static show(msg: Message){
        if(!this.callback) return;
        this.callback(msg);
    }


    //
    // Class
    //

    title: string;
    content:string[] = [];

    constructor(title: string = ''){
        this.title = title;
    }

    add(x:string){
        this.content.push(x);
    }

}